import { request } from "../../base/HTTP";
import HttpMethod from "../../constants/HttpMethod";

export async function getCremationStatements(data) {
    return await request('/api/cremationStatement/search', data);
}

export function getCremationStatementById(id, userId, companyId) {
    return request("api/cremationStatement/" + id, {userId: userId, companyId: companyId}, HttpMethod.GET);
}

export function editCremationStatement(data) {
    return request("api/cremationStatement/", data, HttpMethod.PUT);
}

export function addCremationStatement(data){
    return request("api/cremationStatement/", data, HttpMethod.POST);
}

export function deleteCremationStatement(id, userId, companyId) {
    return request(`api/cremationStatement/${id}?userId=${userId}&companyId=${companyId}`, {}, HttpMethod.DELETE);
}

export function getCremationStatementsByGraveSiteId(id, companyId) {
    return request(`api/cremationStatement/byGraveSite/${id}?companyId=${companyId}`, {}, HttpMethod.GET);
}